export const EAF_SESSION_HEADER = "x-eaf-session-id";

export function bearerToken(header: string | undefined): string | null {
  if (!header) return null;
  const match = /^Bearer\s+([^\s]+)$/i.exec(header);
  return match?.[1] ?? null;
}

export interface VerifiedIdentity {
  providerUid: string;
  email: string;
  emailVerified: boolean;
}
